<ion-header>
  <ion-toolbar color="primary ion-text-center">
    <ion-buttons slot="end">
      <div status-bar></div>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content fullscreen scrollY="false" class="padding content" layout="column">
  <ion-chip *ngIf="!booted">
    <ion-spinner></ion-spinner>
    <ion-label translate="SagaMobile.Cache.Loading"></ion-label>
  </ion-chip>

  <ion-card *ngIf="unitActivity" (click)="openMyUnit()">
    <ion-item>
      <ion-icon [icon]="unitActivity.icon" [color]="unitActivity.color.toRgbString()" slot="start" size="large"></ion-icon>
      <ion-label>
        <h2>{{ unitActivity.rShort() }}</h2>
        <p [style.color]="unitActivity.color.toRgbString()">
          <span [translate]="unitActivity.status.Name"></span>
        </p>
      </ion-label>
    </ion-item>
  </ion-card>

  <ion-card *ngIf="unitActivity && unitActivity.callcard" class="callcard" (click)="openMyCard()">
    <ion-card-header>
      <ion-card-title color="primary">
        <span translate>SagaMobile.MyCard</span>
      </ion-card-title>
    </ion-card-header>
    <ion-item>
      <ion-icon [style.color]="unitActivity.callcard.color.toRgbString()" name="document" slot="start" size="large"></ion-icon>

      <ion-label>
        <h2>{{ unitActivity.callcard.CreatedUTC | moment: 'LLLL' }}</h2>
        <p>{{ unitActivity.callcard.rShort() }}</p>
        <p *ngIf="unitActivity.callcard.event">{{ unitActivity.callcard.event.EventText }}</p>
        <p *ngIf="unitActivity.callcard.location">
          {{ unitActivity.callcard.location.FormattedLocation }}
        </p>
        <p *ngIf="unitActivity.callcard.location?.Complement">
          {{ unitActivity.callcard.location.Complement }}
        </p>
      </ion-label>
    </ion-item>
    <ion-card-header *ngIf="unitActivity.callcard.hasDatabaseChanged || myCardChanged" color="danger">
      <ion-card-subtitle>
        <span translate>SagaMobile.MyCard.Changed</span>
      </ion-card-subtitle>
    </ion-card-header>
  </ion-card>

  <div class="full bottom">
    <div layout="row" class="actions">
      <ion-button fill="outline" (click)="showSettings()">
        <ion-icon slot="icon-only" name="settings"></ion-icon>
      </ion-button>
      <ion-button flex fill="outline" (click)="openMap()">
        <ion-icon name="map" slot="start"></ion-icon>
        <span translate="SagaMobile.Map"></span>
      </ion-button>
    </div>
    <ion-button class="disconnect" expand="block" color="danger" fill="outline" (click)="logout()">
      <div translate="SagaMobile.Disconnect"></div>
    </ion-button>
  </div>
</ion-content>
